;(function () {
  angular.module('contrast.analytics').directive('csAnalytics', csAnalytics)

  function csAnalytics(GoogleAnalyticsService, csAnalyticsEventsService) {
    'ngInject'

    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        var eventKey = attrs.csAnalytics
        var eventDiscriminator = attrs.csAnalyticsDiscriminator

        elem.on('click', function () {
          var event = csAnalyticsEventsService.getEvent(
            eventKey,
            eventDiscriminator
          )
          GoogleAnalyticsService.sendEvent(event)
        })
      }
    }
  }
}).call(this)
